export default function productHero(root: HTMLElement): void {
  const promo = root.querySelector<HTMLElement>('[data-product-hero-promo]');
  const dismiss = promo?.querySelector<HTMLButtonElement>('[data-promo-card-dismiss]');

  dismiss?.addEventListener('click', () => {
    if (promo) {
      promo.hidden = true;
    }
  });
}
